import {ErrorMessage, Field} from "formik";
import {Hint} from "@progress/kendo-react-labels";


export default function FormField({fieldName, label, inputType = "text"}: textFieldProps) {
    label ??= fieldName;
    return (
        <div className="mb-3">
            <label htmlFor={fieldName} className={"form-label"}>{label}</label>
            <Field type={inputType} name={fieldName} id={fieldName} className="form-control"/>
            <ErrorMessage name={fieldName}>{msg => <Hint className="text-danger">{msg}</Hint>}</ErrorMessage>
        </div>
    );
}

interface textFieldProps {
    fieldName: string;
    label?: string;
    inputType?: "text" | "password";
}